import { z } from 'zod';
import { FlowDurationUnits } from '../../../duration/duration.js';
import { FlowBlockValueTemplateDurationSchema, } from '../../blockValue/templateDuration.js';
import { BaseFlowBlockSchema } from '../block.js';
import { FlowBlockType } from '../type.js';
export var FlowMirthMessageType;
(function (FlowMirthMessageType) {
    FlowMirthMessageType["Hl7"] = "Hl7";
    FlowMirthMessageType["Json"] = "Json";
    FlowMirthMessageType["X12"] = "X12";
})(FlowMirthMessageType || (FlowMirthMessageType = {}));
export const FLOW_MIRTH_MAXIMUM_TIMEOUT_DURATION = {
    value: 20,
    units: FlowDurationUnits.Minutes,
};
export const FLOW_MIRTH_DEFAULT_TIMEOUT_DURATION = {
    value: '45',
    units: FlowDurationUnits.Seconds,
};
export const FlowMirthBlockConfigSchema = z.object({
    messageType: z.enum(FlowMirthMessageType),
    message: z.string(),
    path: z.string().optional().default('/'),
    timeout: FlowBlockValueTemplateDurationSchema({
        pathName: 'timeout',
        maxDuration: FLOW_MIRTH_MAXIMUM_TIMEOUT_DURATION,
    }).optional(),
});
export const FlowMirthBlockSchema = BaseFlowBlockSchema.extend({
    type: z.literal(FlowBlockType.Mirth),
    config: FlowMirthBlockConfigSchema,
});
//# sourceMappingURL=config.js.map